/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import pdficonSvg from '../../../../public/pdfico.svg';
import EventService from '../../../../services/EventService';
import ProductService from '../../../../services/ProductService';
import DocumentService from '../../../../services/DocumentService';
import moment from "moment";
import { showLoading } from 'react-global-loading';
import UserService from "../../../../services/UserService";

class PortalStatistics extends React.Component {
  constructor(props) {
    super(props);
    showLoading(true);
    this.state = {
      expandSidebar: false,
      eventData: [],
      productsData: [],
      filteredEvents: [],
      filteredProducts: [],
      docsData: [],
      users: [],
      eventPending: '', docApproved: '', docPending: '', userApproved: '', userPending: '', eventApproved: '', productApproved: '', productPending: '', page: 1, statusType: 1
    };
  }

  componentDidMount = () => {
    this.getAllUsers();
    this.getEventList(this.state.page, this.state.statusType);
    this.getProductList(this.state.page, this.state.statusType);
    this.getAllDocuments(this.state.page, this.state.statusType);
  };

  getAllUsers = () => {
    UserService.getUsersList()
      .then((result) => {
        if (!result) return;

        result?.map((item, index) => {
          item?.status === 'pending' ? this.setState({
            userPending: [...this.state.userPending, item]
          }) : this.setState({
            userApproved: [...this.state.userApproved, item]
          });

        });
        this.setState({ users: result });
        showLoading(false);

      })
      .catch((err) => {
        console.error(err);
      });
  };

  getAllDocuments = (page, status) => {
    DocumentService.getAllDocuments({ 'page': page, 'status': status })
      .then((result) => {
        if (!result) return;
        // result.data?.map((item, index) => {
        //   item?.post_status === 'pending' ? this.setState({
        //     docPending: [...this.state.docPending, item]
        //   }) : this.setState({
        //     docApproved: [...this.state.docApproved, item]
        //   });

        // });
        this.setState({ docsData: result });
        showLoading(false);
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getEventList = (page, status) => {
    EventService.getAllEvents({ 'page': page, 'status': status })
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ eventData: result });
        // result.data?.map((item, index) => {
        //   item?.post_status === 'pending' ? this.setState({
        //     eventPending: [...this.state.eventPending, item]
        //   }) : this.setState({
        //     eventApproved: [...this.state.eventApproved, item]
        //   });
        // });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  getProductList = (page, status) => {
    ProductService.fetchAllProducts({ 'page': page, 'status': status })
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ productsData: result });
        // result.data?.map((item, index) => {
        //   item?.post_status === 'pending' ? this.setState({
        //     productPending: [...this.state.productPending, item]
        //   }) : this.setState({
        //     productApproved: [...this.state.productApproved, item]
        //   });

        // });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  filterType = (status, listType) => {
    // let filteredList = [];
    // for (let i = 0; i < list.length; i++) {
    //   const logFruit = {
    //     1: () => filteredList = list,
    //     3: () => list[i].post_status === "publish" && filteredList.push(list[i]),
    //     4: () => list[i].post_status === "pending" && filteredList.push(list[i])
    //   };
    //   logFruit[type]();
    // }

    switch (listType) {
      case "events"://events
        this.getEventList(1, status)
        break;
      case "products"://products
        this.getProductList(1, status)
        break;
      case "documents"://documents
        this.getAllDocuments(1, status)
        break;
    }

  };

  render() {
    const { productsData, eventData, docsData, users, docApproved, docPending, userApproved, userPending } = this.state;

    return (
      <>
        <div className="container-fluid" id="main">
          <div className="row">
            <div className="col-12">
              <h3 className="t0 text-dark"><b>Ayush Global Portal - Portal Statistics</b></h3>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-12 bg-color-portal">
              <h4>Portal Statistics</h4>
            </div>
          </div> */}
          {/* <div className="row justify-content-around">

          </div> */}
          <div className="row align-items-start mb-4">

            <div className="col-lg-6 col-md-12 mt-4">
              <div className="card overflow-hidden">
                <div className="card-body stats-bg">
                  <div className="events-total justify-content-between">
                    <h5 className="t1">Users - <b>Total {users.length}</b></h5>
                  </div>
                  <div className="d-flex align-items-center justify-content-center">
                    <div className="pe-2 flex-grow-1">
                      <div className="btn-group mt-3 btn-group1 stats-radio-filter" role="group" aria-label="Users Filter">
                        <input type="radio" className="btn-check" name="btnradio" id="btnradio1a" />
                        <label className="btn btn-outline-secondary" htmlFor="btnradio1a">All<span className="badge text-bg-secondary rounded-circle countelm p-2 ml-4">{users.length}</span ></label>
                        <input type="radio" className="btn-check" name="btnradio" id="btnradio2a" />
                        <label className="btn btn-outline-secondary" htmlFor="btnradio2a">Approved<span className="badge text-bg-secondary rounded-circle countelm p-2 ml-4">{userApproved.length}</span></label>
                        <input type="radio" className="btn-check" name="btnradio" id="btnradio3a" />
                        <label className="btn btn-outline-secondary" htmlFor="btnradio3a">Pending<span className="badge text-bg-secondary rounded-circle countelm p-2 ml-4">{userPending.length}</span></label>
                      </div>
                    </div>

                  </div>

                  <ul className="details stats-details-list lstscrl">
                    {users?.map((item, index) => <li key={index}>
                      <div className="detail-group flex">
                        <div className="detail-title flex">
                          <div className="detail-date1 flex">
                            {/* <img src={item?.data?.user_image} alt="flag" /> */}
                            <img src={item?.data?.user_image || require('../../../../public/avtar_placeholder.jpg')} alt="avtar" />
                          </div>
                          <div className="detail-desc1 flex">
                            <div className="usrn_contain">
                              <h5>{item?.data?.display_name}</h5>
                              <div className="usertag d-block">
                                <span className="bg-users">
                                  {/* <i className="fa fa-user" aria-hidden="true"></i> {item?.roles} */}
                                </span>
                              </div>
                            </div>
                            <p className="usrbgim">{item?.data?.user_state}, {item?.data?.user_country[0]?.blogname}</p>


                          </div>
                        </div>

                      </div>
                    </li>)}

                  </ul>
                  <div className="mt-3">
                    <Link to='/super/all-users' className="btn theme-btn-fill btndbg w-100 t1">All</Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 mt-4">
              <div className="card card-body2 overflow-hidden">
                <div className="card-body stats-bg">
                  <div className="events-total justify-content-between">
                    <h5>Products - <b>Total {productsData?.total}</b></h5>
                    <Link to='/super/add-product' className="btn btn-secondary btn-sm">Create</Link>
                  </div>
                  <div className="btn-group mt-3 btn-group1 stats-radio-filter" aria-label="Products Filter">
                    {/* <input type="radio" className="btn-check" name="btnradio" id="btnradio1b" defaultChecked /> */}
                    <label className="btn btn-outline-secondary active" onClick={() => this.filterType(1, "products")} >All<span className="badge text-bg-secondary rounded-circle countelm p-2 ml-4">{productsData?.total}</span></label>
                    {/* <input type="radio" className="btn-check" name="btnradio" id="btnradio2b" /> */}
                    <label className="btn btn-outline-secondary" onClick={() => this.filterType(3, "products")} >Approved<span className="badge text-bg-secondary rounded-circle countelm p-2 ml-4">{productsData?.approved}</span></label>
                    {/* <input type="radio" className="btn-check" name="btnradio" id="btnradio3b" /> */}
                    <label className="btn btn-outline-secondary" onClick={() => this.filterType(2, "products")} >Pending<span className="badge text-bg-secondary rounded-circle countelm p-2 ml-4">{productsData?.pending}</span></label>
                  </div>
                  <ul className="details stats-details-list lstscrl">
                    {productsData?.data?.slice(0, 5).map((productItem, index) => <li key={index}>
                      <div className="detail-group flex">
                        <div className="detail-title flex">
                          <div className="detail-date1 flex">
                            <img src={productItem?.product_image[0] || require('../../../../public/packet.png')} className="rounded-circle" alt="product" />
                          </div>
                          <div className="detail-desc flex">
                            <h5><Link to={{
                              pathname: "/super/products-detail",
                              search: `?id=${productItem?.ID}&blog=${productItem?.country?.id}`,
                              state: { eventDetails: productItem }
                            }} ><b className="crop-text">{productItem?.post_title}</b></Link>
                              {/* <span className="float-end product-cont-name"><Link to='/'><i className="fa fa-user-md" aria-hidden="true"></i> {productItem?.post_content}</Link></span> */}
                            </h5>
                            {/* <div className="productag d-block"><span className="bg-products">{productItem?.post_type}</span></div> */}
                            <div className="producdec d-block text-truncate crop-text">{productItem?.post_content}</div>
                          </div>
                        </div>
                      </div>
                    </li>)}
                  </ul>
                  <div className="mt-3">
                    <Link to="/super/view-products" className="btn theme-btn-fill btndbg w-100">All</Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 mt-4">
              <div className="card card-body2 overflow-hidden">
                <div className="card-body stats-bg">
                  <div className="events-total justify-content-between">
                    <h5>Events - <b>Total {eventData?.total}</b></h5>
                    <Link to='/super/create-event' className="btn btn-secondary btn-sm">Create</Link>
                  </div>
                  <div className="btn-group mt-3 btn-group1 stats-radio-filter" aria-label="Event Filter">
                    {/* <input type="radio" className="btn-check" name="btnradio" id="btnradio1" defaultChecked /> */}
                    <label className="btn btn-outline-secondary" onClick={() => this.filterType(1, "events")} >All<span className="badge text-bg-secondary rounded-circle countelm p-2 ml-4">{eventData?.total}</span></label>
                    {/* <input type="radio" className="btn-check" name="btnradio" id="btnradio2" /> */}
                    <label className="btn btn-outline-secondary" onClick={() => this.filterType(3, "events")} >Approved<span className="badge text-bg-secondary rounded-circle countelm p-2 ml-4">{eventData?.approved}</span></label>
                    {/* <input type="radio" className="btn-check" name="btnradio" id="btnradio3" /> */}
                    <label className="btn btn-outline-secondary" onClick={() => this.filterType(2, "events")} >Pending<span className="badge text-bg-secondary rounded-circle countelm p-2 ml-4">{eventData?.pending}</span></label>
                  </div>
                  <ul className="details stats-details-list lstscrl">
                    {eventData?.data?.slice(0, 4).map((eventItem, index) => <li key={index}>
                      <div className="detail-group flex">
                        <div className="detail-title flex wfll">
                          <div className="detail-date flex">
                            <p>{moment(eventItem?.start_date).format("MMM")}</p>
                            <p>{moment(eventItem?.start_date).format("DD")}</p>
                            <p>{eventItem?.post_status === "pending" ? "Pending" : "Approved"}</p>
                          </div>
                          <div className="detail-desc flex wfll ml-1">
                            <h5 className="evhd_cont">
                              <Link to={{
                                pathname: "/super/event-details",
                                search: `?id=${eventItem?.ID}`,
                                state: { eventDetails: eventItem }
                              }}>
                                <b className="crop-text">{eventItem?.post_title}</b>
                              </Link>
                              <span className="event-cont-name float-end">
                                <Link to='/'><i className="fa fa-user-md" aria-hidden="true"></i> {eventItem?.practitioner_name}</Link>
                              </span>
                            </h5>
                            <div className="d-block ">
                              <small className="usrbgim">{moment(eventItem?.start_date).format("Do MMM YYYY")} <strong className="usrbgim">{eventItem?.select_state}-{eventItem?.select_country.blogname}  </strong></small></div>
                            <div className="event-domains">
                              <span className="badge  fw-normal">{eventItem?.category[0]?.name}</span>
                              {/* <span className="badge rounded-pill fw-normal">Homeopathy</span>
                              <span className="badge rounded-pill fw-normal">Unani</span>
                              <span className="badge rounded-pill fw-normal">Naturopathy</span> */}
                            </div>
                            <div className="eventdec d-block crop-text"><p>{eventItem?.post_content}</p></div>
                          </div>
                        </div>
                      </div>
                    </li>)}
                  </ul>
                  <div className="mt-3">
                    <Link to='/super/view-all-events' className="btn theme-btn-fill btndbg w-100">All</Link>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6 col-md-12 mt-4">
              <div className="card card-body2 overflow-hidden">
                <div className="card-body stats-bg">
                  <div className="events-total justify-content-between">
                    <h5>Documents - <b>Total {docsData?.total}</b></h5>
                    <Link to='/super/add-documents' className="btn btn-secondary btn-sm">Create</Link>
                  </div>
                  <div className="btn-group mt-3 btn-group1 stats-radio-filter" role="group" aria-label="Products Filter">
                    <input type="radio" className="btn-check" name="btnradio" id="btnradio1b" defaultChecked />
                    <label className="btn btn-outline-secondary" htmlFor="btnradio1b" onClick={() => this.filterType(1, "documents")} >
                      All
                      <span className="badge text-bg-secondary rounded-circle m-2 ml-4 countelm">{docsData?.total}</span>
                    </label>
                    <input type="radio" className="btn-check" name="btnradio" id="btnradio2b" />
                    <label className="btn btn-outline-secondary" htmlFor="btnradio2b" onClick={() => this.filterType(3, "documents")}>
                      Approved
                      <span className="badge text-bg-secondary rounded-circle m-2 ml-4 countelm">{docsData?.approved}</span>
                    </label>
                    <input type="radio" className="btn-check" name="btnradio" id="btnradio3b" />
                    <label className="btn btn-outline-secondary" htmlFor="btnradio3b" onClick={() => this.filterType(2, "documents")}>
                      Pending
                      <span className="badge text-bg-secondary rounded-circle m-2 ml-4 countelm">{docsData?.pending}</span>
                    </label>
                  </div>
                  <ul className="details stats-details-list lstscrl">
                    {docsData?.data?.map((docItem, index) => <li key={index}>
                      <div className="detail-group flex">
                        <div className="detail-title flex">
                          <div className="detail-date1 flex">
                            <img src={pdficonSvg} alt="flag" />
                          </div>
                          <div className="detail-desc1 flex">
                            <h5 className="evhd_cont">
                              <b className="crop-text">{docItem?.post_title}</b>
                              <span className="doc-cont-name float-end">
                                <Link to='/'>Uploaded - <b>{moment(docItem?.post_date).format("Do MMM YYYY")}</b></Link>
                              </span>
                            </h5>
                            <p>{docItem?.post_content}</p>
                            <div className="event-domains">
                              <span className="badge rounded-pill fw-normal">{docItem?.category[0]?.name}</span>
                              {/* <span className="badge rounded-pill fw-normal">Homeopathy</span>
                              <span className="badge rounded-pill fw-normal">Unani</span>
                              <span className="badge rounded-pill fw-normal">Naturopathy</span> */}
                            </div>
                            {/* <div className="docdec d-block"><p>Layer boolean font underline project mask polygon hand device device. Clip strike distribute reesizing overflow plugin.</p></div> */}
                          </div>
                        </div>

                      </div>
                    </li>)}

                  </ul>
                  <div className="mt-3">
                    <Link to="/super/all-documents" className="btn theme-btn-fill btndbg w-100">All</Link>
                  </div>
                </div>
              </div>
            </div>

          </div >
        </div >
      </>
    );
  }
}
export default PortalStatistics;